import { Grid } from '@mui/material'
import { CONSTANTS } from '../../Constants/Constant'
import { isAllowKeydown, isPastable } from '../../Helpers/Util'
import MUIDateTimePicker from '../MUIDateTimePicker'
import { MUIFieldWithoutControl, MUIMultiselectAsset } from '../Shared'
import DurationPicker from '../Shared/DurationPicker'
import JSONInputField1 from '../Shared/JSONInputField1'

interface FormRenderProps {
  formFields: any[]
  onChange: (params: any) => void
  addMoreRemoveAction?: (
    ev: any,
    formFieldIndex: number,
    FormJsonIndex: number,
    action: boolean,
  ) => void
  formFieldsOptions?: any
}
const getErrorObject = (item: any) => {
  if (!item.errorMessage) return {}
  return { [item.fieldName]: { message: item.errorMessage } }
}
const FormRender = ({
  formFields,
  onChange,
  addMoreRemoveAction,
  formFieldsOptions,
}: FormRenderProps) => {
  const validFieldTypes = [
    CONSTANTS.FIELDTYPES.TEXT,
    CONSTANTS.FIELDTYPES.NUMBER,
    CONSTANTS.FIELDTYPES.TEXTAREA,
  ]

  const hideNumberFieldArrow = {
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
      { '-webkit-appearance': 'none' },
  }

  const isDurationField = (item: any) =>
    item.fieldType === CONSTANTS.FIELDTYPES.DATETIME &&
    item.dataType === CONSTANTS.FIELDTYPES.NUMBER

  const getSelectOptions = (item: any) => {
    if (item?.formFieldsOptionsKey && formFieldsOptions?.[item.formFieldsOptionsKey]) {
      return formFieldsOptions[item.formFieldsOptionsKey]
    }

    return item?.options
  }

  const renderDurationField = (item: any, index: number) => (
    <Grid item xs={6} md={6} lg={6} xl={6} key={item.id}>
      <DurationPicker
        name={item?.fieldName}
        label={item?.label}
        value={item?.value}
        onChangeValue={(ev: any) => {
          onChange({ ev, index, item })
        }}
        maxHourDigits={4}
        error={getErrorObject(item)}
        required={item?.validations?.required}
      />
    </Grid>
  )

  const renderTextNumberOrTextareaField = (item: any, index: number) => {
    const fieldWidth = item?.fullWidth ? 12 : 6

    return (
      <Grid item xs={fieldWidth} md={fieldWidth} lg={fieldWidth} xl={fieldWidth} key={item.id}>
        <MUIFieldWithoutControl
          style={item?.showNumberFieldArrow ? {} : hideNumberFieldArrow}
          name={item.fieldName}
          type={item.fieldType}
          error={getErrorObject(item)}
          onKeyDown={(ev: any) => {
            const isAllowKey = isAllowKeydown(item.fieldType, ev)
            if (isAllowKey) ev.preventDefault()
          }}
          onPaste={(ev: any) => {
            const pasteTrue = isPastable(item.fieldType, ev)
            if (pasteTrue) ev.preventDefault()
          }}
          label={item.label}
          placeholder={item.label}
          value={item.value}
          onChange={(ev: any) => {
            if (typeof ev === 'string' && item.dataType === CONSTANTS.FIELDTYPES.NUMBER) {
              ev = ev ? Number(ev) : null
            }
            onChange({ ev, index, item })
          }}
          multiline={item.fieldType === CONSTANTS.FIELDTYPES.TEXTAREA}
          required={item?.validations?.required}
        />
      </Grid>
    )
  }

  const renderDateTimeField = (item: any, index: number) => {
    const dateValue = item?.value ? new Date(item.value) : null

    return (
      <Grid item xs={6} md={6} lg={6} xl={6} key={item.id}>
        <MUIDateTimePicker
          label={item?.label}
          type='datetime'
          views={CONSTANTS.DATE_TIME_FORMAT_VIEWS}
          name={item?.fieldName}
          error={getErrorObject(item)}
          value={dateValue}
          onChange={(ev: any) => onChange({ ev, index, item })}
          required={item?.validations?.required}
        />
      </Grid>
    )
  }

  const renderSelectField = (item: any, index: number) => (
    <Grid item xs={6} md={6} lg={6} xl={6} key={item.id}>
      <MUIMultiselectAsset
        name={item?.fieldName}
        className='autocomple-class'
        multiple={item?.isMultiple}
        label={item?.label}
        options={getSelectOptions(item)}
        error={getErrorObject(item)}
        onInputChange={(_ev: any, newValue: any) => {
          onChange({ ev: newValue, index, item })
        }}
        id={item?.fieldName}
        value={item?.value}
        labelKey={item?.labelKey}
        required={item?.validations?.required}
        valueKey={item?.valueKey}
      />
    </Grid>
  )

  const renderJsonField = (item: any, index: number) => (
    <JSONInputField1
      key={item.id}
      label={item?.label}
      error={item?.errorMessage}
      fields={item?.fields}
      addMore={item?.addMore}
      index={index}
      addMoreRemoveAction={addMoreRemoveAction}
      formFieldsOptions={formFieldsOptions}
      onInputChange={onChange}
      fieldId={item.id}
      showAddmoreIcon={item?.showAddmoreIcon}
    />
  )

  return (
    <Grid container spacing={2}>
      {formFields.map((item, index: number) => {
        if (item?.isHidden) {
          return null
        }

        if (isDurationField(item)) {
          return renderDurationField(item, index)
        }

        if (validFieldTypes?.includes(item.fieldType)) {
          return renderTextNumberOrTextareaField(item, index)
        }

        if (item.fieldType === CONSTANTS.FIELDTYPES.DATETIME) {
          return renderDateTimeField(item, index)
        }

        if (item.fieldType === CONSTANTS.FIELDTYPES.SELECT) {
          return renderSelectField(item, index)
        }

        if (item.fieldType === CONSTANTS.FIELDTYPES.JSON1) {
          return renderJsonField(item, index)
        }

        return null
      })}
    </Grid>
  )
}

export default FormRender
